import * as R from 'ramda';
// features
import { columnSettings as serviceVendorColumnSettings } from '../../../service-vendor/settings/column-settings';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
import { intervalUomOptions } from '../../../../helpers/options';
//////////////////////////////////////////////////

const serviceVendorSettings = R.reduce((acc: Object, fieldName: string) => {
  const field = R.prop(fieldName, serviceVendorColumnSettings);

  const { name, type } = field;

  const newField = {
    ...field,
    fieldType: type,
    filterType: G.ifElse(R.includes(type, ['date', 'number']), type, 'string'),
    name: ['titles:service-vendor', ...G.ifElse(G.isArray(name), name, R.of(Array, name))],
  };

  return R.assoc(`${GC.SYSTEM_OBJECT_SERVICE_VENDOR}.${fieldName}`, newField, acc);
}, {}, R.keys(serviceVendorColumnSettings));

export const equipmentServiceTemplateSettings = {
  [GC.FIELD_TEMPLATE_ID]: {
    name: 'titles:template-id',
  },
  [`${GC.FIELD_TRUCK_TYPE}.${GC.FIELD_DISPLAYED_VALUE}`]: {
    name: 'titles:truck-type',
  },
  [`${GC.FIELD_TRAILER_TYPE}.${GC.FIELD_DISPLAYED_VALUE}`]: {
    name: 'titles:trailer-type',
  },
  [`${GC.FIELD_SERVICE_TYPE}.${GC.FIELD_DISPLAYED_VALUE}`]: {
    name: 'titles:service-type',
  },
  [GC.FIELD_INTERVAL_COUNT]: {
    filterType: 'number',
    name: 'titles:interval',
  },
  [GC.FIELD_INTERVAL_UOM]: {
    fieldType: 'uomLocale',
    name: 'titles:interval-uom',
    options: intervalUomOptions,
    filterType: 'selectMultiple',
  },
  [GC.FIELD_BRANCH_DOT_BRANCH_NAME]: {
    name: 'titles:branch',
  },
  [GC.FIELD_CREATED_DATE]: {
    fieldType: 'date',
    filterType: 'date',
    name: 'titles:created-date',
  },
  [GC.FIELD_CREATED_BY]: {
    name: 'titles:created-by',
  },
  [GC.FIELD_LAST_MODIFIED_DATE]: {
    fieldType: 'date',
    filterType: 'date',
    name: 'titles:updated-date',
  },
  [GC.FIELD_LAST_MODIFIED_BY]: {
    name: 'titles:updated-by',
  },
  ...serviceVendorSettings,
};
